import * as S from './styles';

const MobilePlan = () => {
  return (
    <S.Container>
      <S.Inner>
        <S.Title>Enterprise Plan</S.Title>
        <S.SubTitle>리뷰 탐지와 대응, 분석 전 과정의 솔루션</S.SubTitle>
        <S.SolutionList>
          <S.Solution>리뷰 통합 대시보드 제공</S.Solution>
          <S.Solution>
            <S.SolutionEmphasis>멀티 채널 리뷰</S.SolutionEmphasis> 빠짐없이 수집
            <br />
            <S.ExtraInfo>(네이버 카페 / 네이버 블로그 / 강남언니 / 바비톡 등)</S.ExtraInfo>
          </S.Solution>
          <S.Solution>
            리뷰 수집 <S.SolutionEmphasis>알림 서비스</S.SolutionEmphasis> 제공
          </S.Solution>
          <S.Solution>
            <S.SolutionEmphasis>플랫폼 리뷰 삭제</S.SolutionEmphasis> 관리 서비스 <S.ExtraInfo>(매월 10건 무료)</S.ExtraInfo>
          </S.Solution>
          <S.Solution>
            병원 톤앤매너<S.SolutionEmphasis>맞춤 리뷰 대응 서비스</S.SolutionEmphasis> 제공
          </S.Solution>
          <S.Solution>
            월 1회 <S.SolutionEmphasis>인사이트 리포트</S.SolutionEmphasis> 제공
          </S.Solution>
          <S.Solution>AI 추천 답변 자동 등록 기능 제공</S.Solution>
          <S.Solution>AI 리뷰 점수 및 키워드 분석 제공</S.Solution>
          <S.Solution>악성 리뷰 대응 컨설팅 제공</S.Solution>
          <S.Solution>
            방심위 삭제 요청 업무 대행 <S.ExtraInfo>(30만원/건)</S.ExtraInfo>
          </S.Solution>
        </S.SolutionList>
      </S.Inner>
    </S.Container>
  );
};

export default MobilePlan;
